import { withErrorBoundary } from 'components/ErrorBoundary';
import Link from 'components/Globals/Base/Link';
import getCommonTestId from 'constants/testsIds/common';
import type { BreadcrumbsProps } from 'interfaces/navigation/Breadcrumbs';
import { UIFragments } from 'utils/log/constants/uiFragments';
import type { LinkTypes } from 'components/Globals/Base/Link/types';
import * as S from './BreadcrumbsStyles';

const Breadcrumbs = ({ items, hasBrandColor, isHubPage = false }: BreadcrumbsProps) => {
  const trackingData = {
    contentPlacementCD: 'top breadcrumb navigation',
    eventAction: 'click breadcrumb link',
    eventCategory: 'navigation',
  };

  let linkType = 'brandAccentPrimary' as keyof typeof LinkTypes;
  switch (true) {
    case isHubPage:
      linkType = 'brandGray';
      break;
    case hasBrandColor:
      linkType = 'brandAccentPrimary';
      break;
    case !hasBrandColor:
      linkType = 'bluePrimary';
      break;
    default:
      linkType = 'brandAccentPrimary';
      break;
  }

  const mobileItem = items.length > 1 ? items[items.length - 2] : items[0];

  return (
    <S.Wrapper
      aria-label='Breadcrumb'
      className={`breadcrumbs ${isHubPage ? 'hub-page' : ''}`}
      data-cy={getCommonTestId('BREAD_CRUMBS')}
    >
      <S.List
        className={`tablet-and-mobile ${isHubPage ? 'hub-page' : ''}`}
        data-cy={getCommonTestId('TABLET_AND_MOBILE_BREADCRUMBS')}
      >
        <S.CrumbWrapper
          className={isHubPage ? 'hub-page' : ''}
          $isHub={isHubPage}
        >
          {isHubPage ? (
            <Link
              href={items[items.length - 2].link}
              trackingData={{ ...trackingData, eventLabel: items[items.length - 2].label }}
            >
              <S.Crumb
                aria-current='page'
                $last
              >
                {items[items.length - 2].label}
              </S.Crumb>
            </Link>
          ) : (
            <Link
              type={hasBrandColor ? 'brandAccentPrimary' : 'bluePrimary'}
              href={mobileItem?.link}
              trackingData={{ ...trackingData, eventLabel: `${mobileItem.label}` }}
            >
              <S.Crumb>{mobileItem?.label}</S.Crumb>
            </Link>
          )}
        </S.CrumbWrapper>
      </S.List>
      <S.List
        data-cy={getCommonTestId('DESKTOP_BREADCRUMBS')}
        className={isHubPage ? 'hub-page' : ''}
      >
        {items.map((item, index) => (
          <S.CrumbWrapper
            key={item.link}
            className={isHubPage ? 'hub-page' : ''}
            $isHub={isHubPage}
          >
            {index === items.length - 1 && (
              <S.Crumb
                aria-current='page'
                $last
                className={isHubPage ? 'hubPage' : ''}
              >
                {item.label}
              </S.Crumb>
            )}
            {index !== items.length - 1 && (
              <Link
                type={linkType}
                href={item.link}
                trackingData={{ ...trackingData, eventLabel: `${item.label}` }}
                aria-label={item.label}
                className='home'
              >
                <S.Crumb className={isHubPage && index === 0 ? 'home-link' : ''}>{item.label}</S.Crumb>
              </Link>
            )}
          </S.CrumbWrapper>
        ))}
      </S.List>
    </S.Wrapper>
  );
};

export default withErrorBoundary(Breadcrumbs, { fragment: UIFragments.NAVIGATION });
